import { getLocalApi } from "./localApi";
import apiConfig from "app/api/apiConfig.json";
import { DivisionReportTextDto, normalizeDivisionReportTextDto} from "./getDivision";

export type ProductDivision = {
  id: number;
  name: string;
  termsAndConditions?: string;
  groupsPaymentTerms?: string;
  websiteUrl?: string;
  address?: {
    id?: number;
    line1?: string;
    line2?: string;
    line3?: string;
    line4?: string;
    countryISOCode?: string;
    email?: string;
    telephone?: string;
  } | null;
  accreditationBanner?: {
    image?: string;
    contentType?: string;
    fileName?: string;
  } | null;
  isActive?: boolean;
  visaLetterNote?: string | null;
  centreId?: number;
  centre?: { id: number };
  divisionReportTexts?: DivisionReportTextDto[];
};

export async function getDivisionById(id: number | string): Promise<ProductDivision | void> {
  const localApi = await getLocalApi();

  return await localApi.fetchSingle(
    (apiConfig as any).get_product_division_by_id.replace("{divisionId}", String(id)),
    mapDivision,
    "Failed to fetch division by Id"
  );
}

function mapDivision(dto: any): ProductDivision {
  const centreId = dto.centreId ?? dto.centre?.id ?? dto.centreId;
  const existingReportTexts = dto.divisionReportTexts;
  const centreIdFromReportTexts = existingReportTexts && Array.isArray(existingReportTexts) && existingReportTexts.length > 0
    ? existingReportTexts[0]?.centreId
    : undefined;
  
  return {
    id: dto.id,
    name: dto.name ?? dto.divisionName ?? "",
    termsAndConditions: dto.termsAndConditions,
    groupsPaymentTerms: dto.groupsPaymentTerms,
    websiteUrl: dto.websiteUrl ?? dto.websiteLink ?? dto.website,
    address: dto.address
      ? {
          id: dto.address.id,
          line1: dto.address.line1,
          line2: dto.address.line2,
          line3: dto.address.line3,
          line4: dto.address.line4,
          countryISOCode: dto.address.countryISOCode,
          email: dto.address.email,
          telephone: dto.address.telephone,
        }
      : null,
    accreditationBanner: dto.accreditationBanner
      ? {
          image: dto.accreditationBanner.image,
          contentType: dto.accreditationBanner.contentType,
          fileName: dto.accreditationBanner.fileName,
        }
      : null,
    isActive: dto.isActive ?? dto.active,
    visaLetterNote: dto.visaLetterNote ?? dto.visaNotes ?? null,
    centreId: centreId ?? centreIdFromReportTexts,
    centre: dto.centre,
    divisionReportTexts: Array.isArray(existingReportTexts)
      ? existingReportTexts.map(normalizeDivisionReportTextDto)
      : undefined,
  };
}